import Icon from '../components/Icon.vue'

Icon.register({"genderless":{"width":288,"height":512,"paths":[{"d":"M144 176C188.1 176 224 211.9 224 256S188.1 336 144 336 64 300.1 64 256 99.9 176 144 176M144 112C64.5 112 0 176.5 0 256S64.5 400 144 400 288 335.5 288 256 223.5 112 144 112z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/genderless.js
// module id = null
// module chunks = 